import script from "./OrganisationAddPhoneModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrganisationAddPhoneModal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__